<form [formGroup]="multiFieldTextEditorForm" class="cass-multifield-texteditor-control" autocomplete="off">
	<div *ngFor="let field of fields" class="cass-multifield-texteditor-container">
		<div [ngSwitch]="field.model.type" class="cass-multifield-texteditor-field-container">

			<mat-form-field *ngSwitchCase="MultiFieldType.TEXT">
				<mat-label title="{{ field.model.label }}">{{ field.model.label }}</mat-label>
				<input #textControl matInput formControlName="{{ field.model.key }}" required="{{ field.model.config.required }}">
				<mat-icon *ngIf="field.model.description"
						  matSuffix
						  mat-icon-button
						  class="tooltip-button"
						  matTooltip="{{ field.model.description }}"
						  (click)="tooltip.show()"
						  #tooltip="matTooltip"
						  matTooltipPosition="left">
					help
				</mat-icon>
				<mat-error cassErrorForFormControlName="{{ field.model.key }}"></mat-error>
				<div class="symbol-toolbar">
					<button tabindex="-1" *ngFor="let symbol of insertableSymbols" (mousedown)="insertText(textControl, symbol.insert)">{{ symbol.label }}</button>
				</div>
			</mat-form-field>

			<mat-form-field *ngSwitchCase="MultiFieldType.TEXTAREA">
				<mat-label title="{{ field.model.label }}">{{ field.model.label }}</mat-label>
				<textarea #textControl matInput formControlName="{{ field.model.key }}" required="{{ field.model.config.required }}" rows="{{ field.model.config.displaylines }}"></textarea>
				<mat-icon *ngIf="field.model.description"
						  matSuffix
						  mat-icon-button
						  class="tooltip-button"
						  matTooltip="{{ field.model.description }}"
						  (click)="tooltip.show()"
						  #tooltip="matTooltip"
						  matTooltipPosition="left">
					help
				</mat-icon>
				<mat-error cassErrorForFormControlName="{{ field.model.key }}"></mat-error>
				<div class="symbol-toolbar">
					<button tabindex="-1" *ngFor="let symbol of insertableSymbols" (mousedown)="insertText(textControl, symbol.insert)">{{ symbol.label }}</button>
				</div>
			</mat-form-field>

			<div *ngSwitchCase="MultiFieldType.IMAGE" class="image-field">
				<mat-form-field>
					<mat-label title="{{ field.model.label }}">{{ field.model.label }}</mat-label>
					<input matInput formControlName="{{ field.model.key }}" required="{{ field.model.config.required }}" [readonly]="true">
					<mat-error cassErrorForFormControlName="{{ field.model.key }}"></mat-error>
				</mat-form-field>
				<div class="cass-image-commands" *ngIf="!field.model.content && (field.model.config.allowimagegallery || field.model.config.allowimageupload)">
					<button mat-raised-button (click)="startImageGallery(field)" type="button" *ngIf="field.model.config.allowimagegallery">
						<mat-icon>image_search</mat-icon>{{ "ORDER.IMAGES.CHOOSE_LIBRARY_IMAGE_BUTTON_LABEL" | translate }}
					</button>
					<button mat-raised-button (click)="startImageReader(field)" type="button" *ngIf="field.model.config.allowimageupload">
						<mat-icon>upload</mat-icon>{{ "ORDER.IMAGES.UPLOAD_IMAGE_BUTTON_LABEL" | translate }}
					</button>
				</div>
				<div class="cass-image-hidden-controls">
					<input type="file" #cassFileInput name="{{ field.model.key }}" accept="image/png, image/jpeg, image/jpg, image/gif" style="display:none" (change)="handleFileInput(field, $event.target)">
				</div>
				<div class="cass-imageupload-preview" *ngIf="field.model.content && !field.activeImageTool">
					<img [src]="field.model.content" />
					<div class="cass-imageupload-img-commands">
						<button (click)="startImgToolCrop(field)" mat-raised-button *ngIf="field.allowImageToolCrop" type="button">
							{{ "ORDER.IMAGES.CROP_BUTTON_LABEL" | translate }}
						</button>
						<button (click)="removeImg(field)" mat-button mat-raised-button type="button">
							{{ "ORDER.IMAGES.REMOVE_IMAGE_BUTTON_LABEL" | translate }}
						</button>
					</div>
				</div>
				<div class="cass-multifield-texteditor-croptool-container" *ngIf="field.activeImageTool === MultiFieldActiveTool.CROP">
					<image-cropper [imageBase64]="field.model.content || ''" (imageCropped)="imgCropped(field.model, $event)" [cropperMinWidth]="field.model.cropResizeConstraints?.cropMinWidth || 0" [cropperMaxWidth]="field.model.cropResizeConstraints?.cropMaxWidth || 0"
								   [cropperMinHeight]="field.model.cropResizeConstraints?.cropMinHeight || 0" [cropperMaxHeight]="field.model.cropResizeConstraints?.cropMaxHeight || 0"
								   [maintainAspectRatio]="field.model.cropResizeConstraints?.maintainAspectRatio || false" [aspectRatio]="field.model.cropResizeConstraints?.aspectRatio || 1"></image-cropper>
					<button (click)="toolCommandDoCrop(field)" mat-raised-button color="primary" type="button">{{ "ACTION_BUTTON_LABELS.APPLY" | translate }}</button>
				</div>
				<mat-icon *ngIf="field.model.description"
						   matSuffix
						   mat-icon-button
						   class="tooltip-button"
						   matTooltip="{{ field.model.description }}"
						   (click)="tooltip.show()"
						   #tooltip="matTooltip"
						   matTooltipPosition="left">
					help
				</mat-icon>
			</div>
		</div>
	</div>
</form>
